var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles),domProps:{"innerHTML":_vm._s(require(("@/assets/icons/" + _vm.icon + ".svg")))}})}
var staticRenderFns = []

export { render, staticRenderFns }